import React from 'react'
import moment from 'moment'
import { HeaderContainer, Timer } from '../allocationDialogStyles'
import { CountdownTimer, timeConstants } from 'view/components/timers'
import { DateLike } from 'utils'
import { Locale, Translation } from 'locale'

interface AssignmentHeaderProps {
  name: string
  expiryTime: DateLike | null
  children?: React.ReactNode
}

export const AssignmentHeader: React.FunctionComponent<AssignmentHeaderProps> = props => {
  const { name, expiryTime, children } = props

  return (
    <HeaderContainer>
      <span>{name}</span>
      {expiryTime && (
        <Timer>
          <CountdownTimer
            label={Locale.translate(Translation.TC_REMAINING_ASSIGNMENT_TIME)}
            expiryTime={moment(expiryTime)}
            urgentTime={timeConstants.fundAssignmentUrgent}
            expiringTime={timeConstants.fundAssignmentExpiring}
            dataTestId={'FundAssignmentDialog-RemainingAssignmentTime'}
          />
        </Timer>
      )}
      {children}
    </HeaderContainer>
  )
}
